import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import common_en from "./translations/en/common.json";
import common_hi from "./translations/hi/common.json";
import { CookiesProvider } from "react-cookie";
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
//import '../public/Assets/css/semantic.min.css'
//import 'semantic-ui-css/semantic.css';
//import "./Assets/Css/semantic.css"
import "react-datepicker/dist/react-datepicker.css";  
//import 'semantic-ui/dist/semantic.min.css';



i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'en',                              // language to use
  resources: {
      en: {
          common: common_en               // 'common' is our custom namespace
      },
      hi: {
          common: common_hi
      },
  }
});

ReactDOM.render(
  <BrowserRouter>
   <CookiesProvider>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
    </CookiesProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
